import { useFetchAllTimeLinesQuery } from '@redux/api/timeline.api'

import { useHandlers } from './useHandlers'

export const useConfigTimeLines = () => {
  const { data: timelines, isFetching, refetch } = useFetchAllTimeLinesQuery()

  const { state, handlers } = useHandlers({ refetchAllTimeLines: refetch })

  return {
    state: {
      ...state,
      isLoadingAllTimeLines: isFetching,
    },
    data: {
      timelines,
    },
    handlers,
  }
}
